// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3E5Ef","content":"styles_content__3rYIO","checkbox":"styles_checkbox__ciJHB","checkboxLabel":"styles_checkboxLabel__1VcyV"};